export default {
    faceCheck:{
        interval:5,//每次调起人脸识别后的间隔拍照时间，单位：秒
    }
}



// WEBPACK FOOTER //
// ./src/common/config.js